import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { HiMenu } from "react-icons/hi";
import logoPinguino from "./images/logoPinguinoMiniso1.png";
import logoPinguinoRojo from "./images/logoPinguinoRojo.png";
import logoMiBolsa from "./images/logoBolsa2.png";
import logoBolsoRojo from "./images/logoBolsoRojo.png";
import logoUneteMiniso from "./images/minisoLove1.png";
import MioffCanvas from "./MioffCanvas";
import Categories from "./Categories/Categories";
import Busqueda from "./Busqueda/Busqueda";
import {
  headerGif,
  headerGifDesktop,
  logoHeaderMinisoDesktop,
  logoHeaderMinisoMobile,
} from "../../../assets/ImgLinks";

const HeaderMiniso = () => {
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const [activePinguin, setActivePinguin] = useState(false);
  const [activeBolso, setActiveBolso] = useState(false);
  const handleCanvas = () => {
    setShowOffCanvas((prev) => !prev);
  };
  const toggleActivePinguin = () => {
    setActivePinguin((prev) => !prev);
  };
  const toggleActiveBolso = () => {
    setActiveBolso((prev) => !prev);
  };
  return (
    <div className="bg-white pb-2">
      {/* <img  className="d-block d-lg-none w-100" src={headerGif} alt="banner" />
      <img  className="d-none d-lg-block w-100" src={headerGifDesktop} alt="banner" /> */}

      <Container
        fluid
        className="d-flex align-items-center justify-content-between py-2"
      >
        <div
          style={{ cursor: "pointer" }}
          className="d-flex align-items-center d-lg-none"
        >
          <HiMenu onClick={handleCanvas} className="fs-1" />
          <a href="https://www.miniso.com.mx/">
            <img
              style={{ width: "50px" }}
              src={logoHeaderMinisoMobile}
              alt="logoHeaderMinisoMobile"
            />
          </a>
          <MioffCanvas
            className="d-lg-none"
            showOffCanvas={showOffCanvas}
            setShowOffCanvas={setShowOffCanvas}
          />
        </div>
        <div className="d-flex w-50 align-items-center">
          <a href="https://www.miniso.com.mx/">
            <img
              className="d-none d-lg-block"
              src={logoHeaderMinisoDesktop}
              alt="logoHeaderMinisoDesktop"
            />
          </a>
          <Container fluid className="d-none d-lg-flex w-100 h-75">
            <Busqueda />
          </Container>
        </div>

        <div className="d-flex align-items-center me-3">
          <div className="d-none d-lg-flex align-items-center">
            <p className="me-2 mt-3 small">Únete a </p>
            <a href="https://www.miniso.com.mx/minisolove">
              <img src={logoUneteMiniso} alt="logoUneteMiniso" />
            </a>
          </div>
          <a href="https://www.miniso.com.mx/login?returnUrl=%2F">
            <img
              className="ms-3 me-4"
              onMouseOver={toggleActivePinguin}
              onMouseLeave={toggleActivePinguin}
              src={activePinguin ? logoPinguinoRojo : logoPinguino}
              alt="logoPinguino"
            />
          </a>
          <a href="https://www.miniso.com.mx/login?returnUrl=%2F">
            <img
              className="ps-4 border-2 border-start"
              onMouseOver={toggleActiveBolso}
              onMouseLeave={toggleActiveBolso}
              src={activeBolso ? logoBolsoRojo : logoMiBolsa}
              alt="logoMiBolsa"
            />
          </a>
        </div>
      </Container>
      <Container fluid className="d-lg-none">
        <Busqueda />
      </Container>

{/*       <div className="d-none d-lg-block">
        <Categories />
      </div> */}
    </div>
  );
};

export default HeaderMiniso;
